<template>
  <el-card class="mangement-compontent" v-if="show">
    <div class="left">
      <el-tree
        :props="propsData"
        :load="loadNode"
        lazy
        show-checkbox
        node-key="id"
        @check="handleCheck">
      </el-tree>
    </div>
    <div class="right">
      <div class="search-content">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="">
            <el-input clearable v-model="searchForm.name" placeholder="人员姓名"></el-input>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="end" class="operation">
          <el-col :span="4">
            <div style="display: flex;justify-content: end;">
              <el-button type="primary" @click="search">搜索</el-button>
              <el-button type="warning" @click="syncData" :disabled="loading">同步钉钉数据</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="table-content">
        <el-table ref="dataTable" v-loading="loading" element-loading-text="拼命加载中" :data="tableData"  header-cell-class-name="table-header-cell"  border stripe>
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column prop="name" label="姓名" :show-overflow-tooltip="false"></el-table-column>
          <el-table-column prop="department" label="部门" :show-overflow-tooltip="false"></el-table-column>
          <el-table-column prop="title" label="职位" :show-overflow-tooltip="false"></el-table-column>
          <el-table-column prop="state" label="状态" :show-overflow-tooltip="false">
            <template slot-scope="scope">
              <el-tag :type="scope.row.state === 0 ? 'success' : 'danger'">{{ scope.row.state === 0 ? '在职' : '离职' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="region" label="管辖范围" :show-overflow-tooltip="false"></el-table-column>
          <el-table-column label="操作" width="180" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" v-if="scope.row.state === 0" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="primary" plain size="mini" @click="handleDetails(scope.row)">扫码记录</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" class="page">
          <el-col>
            <div style="display: flex; justify-content: end;">
              <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="searchForm.current" :page-sizes="[10, 15, 30, 50]" :page-size="searchForm.size"
                layout="total, sizes, prev, pager, next, jumper" :total="totalData"></el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      append-to-body
      title="修改管辖区域"
      :close-on-click-modal="false"
      :visible.sync="dialogShow"
      width="30%"
      :before-close="handleCloseDialog">
      <div class="dialog-content">
        <el-form ref="editForm" :model="editForm" label-width="100px">
          <el-form-item label="姓名">
            <el-input size="small" v-model="nameText" disabled></el-input>
          </el-form-item>
          <el-form-item label="部门">
            <el-input size="small" v-model="departmentText" disabled></el-input>
          </el-form-item>
          <el-form-item label="职位">
            <el-input size="small" v-model="titleText" disabled></el-input>
          </el-form-item>
          <el-form-item label="管辖区域">
            <el-input v-model="editForm.region" placeholder="请输入管辖区域"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseDialog">取 消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
  <el-card class="history-content" v-else>
    <div class="title">
      <div class="title-text">{{userName}}的扫码历史记录</div>
    </div>
    <div class="search-content">
      <el-form :inline="true" :model="historyForm" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="historyForm.score" clearable placeholder="选择评价星级" @change="searchHistory">
            <el-option
              v-for="item in starList"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select clearable v-model="historyForm.isCheck" placeholder="是否核验成功" @change="searchHistory">
            <el-option label="核验成功" value="1"></el-option>
            <el-option label="核验失败" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-date-picker
            v-model="dateTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="handleChangeTime">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="end" class="operation">
        <el-col :span="4">
          <div style="display: flex;justify-content: end;">
            <el-button type="primary" @click="searchHistory">搜索</el-button>
            <el-button type="primary" size="small" @click="handleBack">返回</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table ref="dataTable" v-loading="historyLoading" :data="historyData"  header-cell-class-name="table-header-cell"  border stripe>
      <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
      <el-table-column prop="confirmTime" label="时间" min-width="100" :show-overflow-tooltip="false"></el-table-column>
      <el-table-column prop="address" label="定位地址" min-width="280" :show-overflow-tooltip="false"></el-table-column>
      <el-table-column label="评分" :show-overflow-tooltip="false">
        <template slot-scope="scope">
          <span v-if="scope.row.score == 0">未评分</span>
          <span v-else>{{scope.row.score}}星</span>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="评价" min-width="280" :show-overflow-tooltip="false">
        <template slot-scope="scope">
          <span v-if="scope.row.content ">{{scope.row.content}}</span>
          <span v-else>未评价</span>
        </template>
      </el-table-column>
      <el-table-column prop="department" label="部门" :show-overflow-tooltip="false"></el-table-column>
      <el-table-column prop="title" label="职位" :show-overflow-tooltip="false"></el-table-column>
      <el-table-column prop="region" label="管辖范围" min-width="280" :show-overflow-tooltip="false"></el-table-column>
      <el-table-column prop="photos" label="现场照片" width="120" align="center">
        <template slot-scope="scope">
          <span style="cursor: pointer;color: #1890ff;" v-if="scope.row.photos && scope.row.photos.length > 0" @click="viewImages(scope.row)">点击查看</span>
          <span v-else>无</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="100" align="center">
        <template slot-scope="scope">
          <el-button type="danger" size="small" @click="delRecord(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="end" class="page">
      <el-col>
        <div style="display: flex; justify-content: end;">
          <el-pagination 
            background 
            @size-change="handleHistorySizeChange" 
            @current-change="handleHistoryCurrentChange"
            :current-page="historyForm.current" 
            :page-sizes="[10, 15, 30, 50]" 
            :page-size="historyForm.size"
            layout="total, sizes, prev, pager, next, jumper" :total="historyTotal">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      append-to-body
      width="600px"
      :close-on-click-modal="false"
      :title="imgModalTitle"
      :visible.sync="imgModalVisible"
      @before-close="imgModalVisible = false">
      <div class="img-wrapper">
        <el-image 
          v-for="(item,index) in photosList"
          :key="index"
          style="width: 260px; height: 260px;margin-right: 10px;"
          :src="item" 
          :preview-src-list="[item]">
        </el-image>
      </div>
    </el-dialog>
  </el-card>
</template>
<script>
import dayjs from 'dayjs'
import {
  getDeptLevle,
  getDeptSubsById,
  getUserList,
  updateRegin,
  getSyncData,
  getRecord,
  delRecord,
  getRecordPhotos
} from '@/api/index.js'
export default {
  name: 'Management',
  components: {},
  props: {
    state: {
      type: Boolean,
      default: false
    },
    starList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    state(val) {
      if (val) {
        this.show = true
      }else {
        this.show = false
      }
      this.search()
    }
  },
  data() {
    return {
      show:true,
      loading: false,
      searchForm: {
        current: 1,
        size: 10,
        deptIds:[]
      },
      userId:'',
      nameText: '',
      departmentText: "",
      titleText:'',
      propsData: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf'
      },
      tableData: [],
      totalData: 0,
      dialogShow: false,
      editForm: {},
      historyData: [],
      historyTotal: 0,
      historyLoading: false,
      userName: '',
      dateTime:[],
      historyForm: {
        current: 1,
        size: 10,
        isCheck:'1',
        beginTime:'',
        endTime:'',
      },
      photosList: [],
      photoSrc: '',
      imgModalTitle: '',
      imgType: '',
      imgModalVisible: false,
    }
  },
  created() { 
    this.getTableData()
  },
  methods: {
    search() {
      this.searchForm.current = 1
      this.getTableData()
    },
    handleBack() { 
      let startTime = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss')
      let endTime = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.show = true
      this.dateTime = [startTime,endTime]
      this.historyForm = {
        current: 1,
        size: 10,
        isCheck:'1',
        beginTime:startTime,
        endTime:endTime,
      }
    },
    syncData() { 
      this.$confirm('该操作将会从钉钉上的组织架构和人员数据中获取数据，同步覆盖工牌系统的对应数据，请问是否确认？', '同步钉钉数据确认', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true
        getSyncData().then(res => { 
          if (res.code === '200') {
            this.loading = false
            this.$message({
              type: 'success',
              message: '同步成功'
            });
          }
        })
      }).catch(action => {
        this.$message({
          type: 'info',
          message: action === 'cancel' ? '取消同步'  : '取消同步'
        })
      });
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        getDeptLevle(1).then(res => {
          if (res.code === '200') {
            let arr = []
            let d = res.result
            d.forEach(item => {
              arr.push({
                name: item.name,
                id:item.id
              })
            })
            return resolve(arr);
          }
        })
      } else { 
        getDeptSubsById(node.data.id).then(res => {
          if (res.code === '200') {
            let arr = []
            let d = res.result
            d.forEach(item => {
              arr.push({
                name: item.name,
                id:item.id
              })
            })
            return resolve(arr);
          }
        })
      }
    },
    handleCheck(d,v) {
      let data = v.checkedNodes
      if (data.length === 0) {
        this.searchForm.deptIds = []
      } else { 
        this.searchForm.deptIds = []
        v.checkedNodes.forEach(item => {
          this.searchForm.deptIds.push(item.id)
        })
      }
      this.search()
    },
    async getTableData() { 
      this.loading = true
      let res = await getUserList(this.searchForm)
      if (res.code === '200') {
        this.loading = false
        this.tableData = res.result.records
        this.totalData = res.result.total
      }
    },
    handleSizeChange(v) { 
      this.searchForm.size = v
      this.getTableData()
    },
    handleCurrentChange(v) { 
      this.searchForm.current = v
      this.getTableData()
    },
    
    handleEdit(d) { 
      this.nameText = d.name
      this.departmentText = d.department
      this.titleText =d.title
      this.editForm = {
        id:d.id,
        region:d.region
      }
      this.dialogShow = true
    },
    handleDetails(d) {
      this.show = false
      this.userName = d.name
      this.historyForm.userId = d.id
      this.gethistoryTableData()
    },
    async handleSubmit() { 
      let params = {
        id:this.editForm.id,
        region:this.editForm.region
      }
      let res = await updateRegin(params)
      if (res.code === '200') {
        this.$message.success('修改成功')
        this.handleCloseDialog()
        this.search()
      }
    },
    handleCloseDialog() { 
      this.dialogShow = false
      this.editForm = {}
    },
    searchHistory() { 
      this.historyForm.current = 1
      this.gethistoryTableData(this.userId)
    },
    async gethistoryTableData() { 
      this.historyLoading = true
      let res = await getRecord(this.historyForm)
      if (res.code == '200') {
        this.historyLoading = false
        this.historyData = res.result.records
        this.historyTotal = res.result.total
      }
    },
    handleHistorySizeChange(v) {
      this.historyForm.size = v
      this.gethistoryTableData()
    },
    handleHistoryCurrentChange(v) { 
      this.historyForm.current = v
      this.gethistoryTableData()
    },
    handleChangeTime(v) { 
      if (v) {
        this.historyForm.beginTime = dayjs(v[0]).format('YYYY-MM-DD HH:mm:ss')
        this.historyForm.endTime = dayjs(v[1]).format('YYYY-MM-DD HH:mm:ss')
      } else { 
        this.historyForm.beginTime = ''
        this.historyForm.endTime = ''
      }
      this.gethistoryTableData()
    },
    async viewImages(d) {
      let res = await getRecordPhotos(d.id)
      if (res.code === '200') {
        this.photosList = res.result.photos
        this.photoSrc = this.photosList[0]
        this.imgModalVisible = true;
      }
    },
    delRecord(d) { 
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delRecord(d.id).then(res => {
          if (res.code === '200') {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.gethistoryTableData()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>
<style scoped>
.mangement-compontent{
  text-align: left;
}
.mangement-compontent /deep/ .el-card__body {
  display: flex;
  justify-content: space-between;
}
.mangement-compontent .left{
  width: 360px;
  border-right: 2px solid #ddd;
}
.mangement-compontent .right{
  width: calc(100% - 370px);
}
.search-content {
  display: flex;
  justify-content: space-between;
}
.page {
  padding-top: 10px;
}
.history-content {
  text-align: left;
}
.history-content .title {
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
}
.history-content .title-text{
  font-size: 20px;
}
.img-wrapper {
  text-align: center;
}
</style>